export const backendUrl = (() => {
  const raw = process.env.REACT_APP_BACKEND_URL;
  if (raw && raw.trim() !== "") {
    return raw.replace(/\/$/, "");
  }
  return window.location.origin;
})();

export const apiUrl = (path) => {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${backendUrl}${p}`;
};
